import { app } from "@/main";
import axios from "axios";
import { createWebHistory, createRouter } from "vue-router";

const ProvidersLayout = () => import('@/Layout/ProvidersLayout');
const ProvidersAuthLayout = () => import('@/Layout/ProvidersAuthLayout');

//auth pages
const ProvidersLogin = () => import('@/Pages/Login');
const ProvidersContracts = () => import('@/Pages/Contracts');
const ProvidersCustomers = () => import('@/Pages/Customers');
const ProvidersImportExport = () => import('@/Pages/ImportExport');
const ProvidersInvoices = () => import('@/Pages/Invoices');

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: `/business`,
  routes: [
    {
      path: `/`,
      component: ProvidersAuthLayout,
      meta: {
        guest: true
      },
      children: [
        {
          path: '/',
          redirect: () => 'login',
          meta: {
            title: 'Login'
          }
        },
        {
          path: 'login',
          name: 'login',
          component: ProvidersLogin,
          meta: {
            title: 'Login'
          }
        }
      ]
    },
    {
      path: `/`,
      component: ProvidersLayout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/',
          redirect: () => 'contracts',
          meta: {
            title: 'Contracts '
          }
        },
        {
          path: 'contracts',
          name: 'providers-contracts',
          meta: {
            title: 'Contracts '
          },
          component: ProvidersContracts
        },
        {
          path: 'customers',
          name: 'customers',
          meta: {
            title: 'Customers '
          },
          component: ProvidersCustomers
        },
        {
          path: 'import-export',
          name: 'import-export',
          meta: {
            title: 'Import'
          },
          component: ProvidersImportExport
        },
        {
          path: 'invoices',
          name: 'providers-invoices',
          meta: {
            title: 'Invoices '
          },
          component: ProvidersInvoices
        },
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token')
  const DEFAULT_TITLE = 'ExitLag Providers';
  document.title = DEFAULT_TITLE + ' - ' + to.meta.title || DEFAULT_TITLE;

  try {
    if (to.path === '/login') {
      throw Error()
    }
    if (!token && to.matched.some(record => record.meta.requiresAuth)) {
      return next({
        path: '/login',
      });
    } else if (token && to.matched.some(record => record.meta.guest)) {
      return next({
        path: '/contracts',
      })
    }
    await axios
      .post(`${process.env.VUE_APP_API_URL}/auth/verify`, {},
        {
          headers: { Authorization: `Bearer ${token}` }
        })
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
    app.config.globalProperties.$axios = axios;
    next()
  } catch (err) {
    localStorage.removeItem('token')
    if (to.path !== '/login') {
      next({
        path: '/login',
      });
    } else {
      next()
    }
  }
})

export default router